import React from 'react';
import PropTypes from 'prop-types';

class IngredientsBlock extends React.PureComponent {
  render() {
    const { tt: { ingredients } } = this.props;
    return (
      <div className="block ingredients" id="ingredients">
        <div className="container">
          <div className="title">
            {ingredients.title}
          </div>
          <div className="row">
            <div className="col m4">
              <div className="promo">
                <div className="img-block">
                  <div className="img img-1" />
                </div>
                <div className="title">{ingredients.quality.title}</div>
                <div className="text">{ingredients.quality.text}</div>
              </div>
            </div>
            <div className="col m4">
              <div className="promo">
                <div className="img-block">
                  <div className="img img-2" />
                </div>
                <div className="title">{ingredients.natural.title}</div>
                <div className="text">{ingredients.natural.text}</div>
              </div>
            </div>
            <div className="col m4">
              <div className="promo">
                <div className="img-block">
                  <div className="img img-3" />
                </div>
                <div className="title">{ingredients.imported.title}</div>
                <div className="text">{ingredients.imported.text}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

IngredientsBlock.propTypes = {
  tt: PropTypes.object,
};

IngredientsBlock.defaultProps = {
  tt: {},
};

export default IngredientsBlock;



// WEBPACK FOOTER //
// ./src/HomePage/blocks/IngredientsBlock/index.js